module.exports = __webpack_public_path__ + "static/media/LogoAHD.36d3c0ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/LogoAHD.jpg
// module id = 1144
// module chunks = 0